import { Anchor, Ship, Navigation, Instagram, Youtube } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-50 border-t">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-8">
          {/* Logo */}
          <img
            src="/logo.png"
            alt="Roda de Proa"
            className="h-12 w-auto"
          />

          {/* Links de Navegação */}
          <nav className="flex flex-wrap justify-center gap-8">
            <a
              href="https://navegueseguro.rodadeproa.com.br/arrais/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
            >
              <Ship className="w-6 h-6 mr-2 text-blue-600" />
              <span>Arrais Amador</span>
            </a>
            <a
              href="https://cpa.rodadeproa.com.br/ebook-msa/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
            >
              <Anchor className="w-6 h-6 mr-2 text-blue-600" />
              <span>Mestre Amador</span>
            </a>
            <a
              href="https://cpa.rodadeproa.com.br/curso/home/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
            >
              <Navigation className="w-6 h-6 mr-2 text-blue-600" />
              <span>Capitão Amador</span>
            </a>
          </nav>

          {/* Redes Sociais */}
          <div className="flex space-x-6">
            <a
              href="https://instagram.com/rodadeproa"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              <Instagram className="w-6 h-6" />
            </a>
            <a
              href="https://youtube.com/@rodadeproa"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-blue-600 transition-colors"
            >
              <Youtube className="w-6 h-6" />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Roda de Proa. Todos os direitos reservados.
          </div>
        </div>
      </div>
    </footer>
  );
}
